var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-5 d-flex"},[_c('div',[_c('ul',{staticClass:"progressbar m-0 px-3"},_vm._l((_vm.labels),function(label,index){return _c('li',{key:index,class:{ 
                active: _vm.step == index+1,
                complete: _vm.step > index+1
            }},[_vm._v(" "+_vm._s(label)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }